var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { autorun } from 'mobx';
import { observer } from 'mobx-react';
import { IntlProvider } from 'react-intl';
import History from './services/History';
import Session from './services/Session';
import ApplicationStartupCommand from './commands/authentication/ApplicationStartupCommand';
import Views from './views/Views';
import { ApplicationContext } from './ApplicationContext';
import translationsCommon from '../lang/translations.common.json';
import { getTranslations } from './utils/translations';
import Signals from './signals/Signals';
import Cookies, { COOKIE_TYPES } from './services/Cookies';
import AssetCollection from './collections/assets/AssetCollection';
import LabelCollection from './collections/labels/LabelCollection';
import FeedCollection from './collections/feeds/FeedCollection';
import UserCollection from './collections/users/UserCollection';
import InviteCollection from './collections/invites/InviteCollection';
import ArchivedAssetCollection from './collections/assets/ArchivedAssetCollection';
import ServiceSchemaCollection from './collections/services/ServiceSchemaCollection';
import ServiceEntryCollection from './collections/services/ServiceEntryCollection';
import ReportCollection from './collections/reports/ReportCollection';
import ApplicationModel from "./models/ApplicationModel";
import DeviceCollection from "./collections/devices/DeviceCollection";
import ResfreshingAssetsOnInterval from './commands/assets/RefreshingAssetsOnInterval';
import RefreshingState from './models/RefreshingState';
import GetAllAssetIconsCommand from './commands/assets/GetAllAssetIconsCommand';
import { initializeDatePickerEnvironment } from './utils/datePickerUtils';
/**
 *
 */
var Application = /** @class */ (function (_super) {
    __extends(Application, _super);
    /**
     *
     * @param props
     */
    function Application(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            history: History,
            session: Session,
            translations: translationsCommon,
            assetRefreshingEnabled: RefreshingState.Enabled,
            refreshingIntervalInMilliseconds: 300 * 1000,
            refreshingIntervalObject: new ResfreshingAssetsOnInterval(),
            assetCollection: new AssetCollection(),
            labelCollection: new LabelCollection(),
            feedCollection: new FeedCollection(),
            userCollection: new UserCollection(),
            inviteCollection: new InviteCollection(),
            archivedAssetCollection: new ArchivedAssetCollection(),
            serviceSchemaCollection: new ServiceSchemaCollection(),
            serviceEntryCollection: new ServiceEntryCollection(),
            reportCollection: new ReportCollection(),
            deviceCollection: new DeviceCollection(),
            assetIconNameToIconUrlDictionary: new Map(),
            assetsInitialized: false,
            applicationModel: new ApplicationModel(),
            temp: false
        };
        // Initialize session
        try {
            var storedJWT = Cookies.getCookie(COOKIE_TYPES.JWT);
            Session.setJWT(storedJWT ? storedJWT : null, true);
        }
        catch (e) {
            console.log(e);
        }
        Session.initialLocation = JSON.parse(JSON.stringify(History.location));
        //
        Signals.LoggedOut.add(function () {
            _this.reset();
            _this.forceUpdate();
        });
        Signals.LoggedIn.add(function () {
            _this.forceUpdate();
        });
        //
        _this.onHashChange = _this.onHashChange.bind(_this);
        return _this;
    }
    /**
     *
     * @param error
     * @param info
     */
    Application.prototype.componentDidCatch = function (error, info) {
        Signals.ShowNotification.dispatch('Er is iets misgegaan: ' + error, 'danger');
    };
    /**
     *
     */
    Application.prototype.componentDidMount = function () {
        var _this = this;
        autorun(function () {
            var checkObject = {
                isLoggedIn: _this.state.session.isLoggedIn,
            };
            if (_this.state.session.isLoggedIn && !_this.state.assetsInitialized && !_this.state.session.user.requiresOnBoarding) {
                var getIconsCommand = new GetAllAssetIconsCommand();
                var icons = getIconsCommand.execute(Session.user.organisation);
                _this.setState({ assetIconNameToIconUrlDictionary: icons, assetsInitialized: true });
            }
        });
        // Do login sequence
        var command = new ApplicationStartupCommand();
        command.execute().finally(function () {
            _this.forceUpdate();
        });
        this.state.refreshingIntervalObject.create(this.state.refreshingIntervalInMilliseconds);
        Signals.ToggleAssetRefreshingOnInterval.add(this.toggleRefreshingEnabled.bind(this));
        initializeDatePickerEnvironment();
        window.addEventListener("hashchange", this.onHashChange);
    };
    Application.prototype.toggleRefreshingEnabled = function () {
        if (this.state.assetRefreshingEnabled == RefreshingState.Enabled)
            this.setState({ assetRefreshingEnabled: RefreshingState.Disabled });
        else
            this.setState({ assetRefreshingEnabled: RefreshingState.Enabled });
    };
    /**
     *
     * @return {*}
     */
    Application.prototype.render = function () {
        var _a = this.state, history = _a.history, translations = _a.translations;
        var locale = Session.locale;
        var messages = getTranslations(translations, locale);
        window.messages = messages; // Make globally available
        return (React.createElement(IntlProvider, { defaultLocale: locale, locale: locale, messages: messages },
            React.createElement(ApplicationContext.Provider, { value: __assign({}, this.state) },
                React.createElement(Views, null))));
    };
    /**
     *
     */
    Application.prototype.onHashChange = function () {
        Signals.HashChanged.dispatch();
    };
    /**
     * Reset all collections after logging out
     */
    Application.prototype.reset = function () {
        var _a = this.state, assetCollection = _a.assetCollection, labelCollection = _a.labelCollection, feedCollection = _a.feedCollection, userCollection = _a.userCollection, inviteCollection = _a.inviteCollection, archivedAssetCollection = _a.archivedAssetCollection, serviceSchemaCollection = _a.serviceSchemaCollection, serviceEntryCollection = _a.serviceEntryCollection, reportCollection = _a.reportCollection, deviceCollection = _a.deviceCollection;
        assetCollection.resetAll();
        labelCollection.resetAll();
        feedCollection.reset();
        userCollection.reset();
        inviteCollection.reset();
        archivedAssetCollection.reset();
        serviceSchemaCollection.reset();
        serviceEntryCollection.reset();
        reportCollection.reset();
        deviceCollection.reset();
    };
    Application = __decorate([
        observer
    ], Application);
    return Application;
}(React.Component));
export default Application;
